import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import ReportablePartsWidget from './ReportablePartsWidget'

// Registers the "Reportable parts" MOS widget: shows the reportable parts of the active job
// (GET mos/fabricationOrderReportQuantity/reportableParts/{fabricationOrderId}/{jobReferenceId}).
class ReportablePartsWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'ReportablePartsWidget'

  getName = () => 'Reportable parts'

  getIcon = () => FactCheckOutlinedIcon

  createWidget = (props) => <ReportablePartsWidget {...props} />

  createPreviewWidget = (props) => <ReportablePartsWidget {...props} preview />

  size = { defaultW: 2, defaultH: 2, minW: 1, minH: 1 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size) }
  }
}

export default ReportablePartsWidgetProvider
